'use strict';
var $ = window.jQuery;
var validateTextField = require('../common/validate-textfield');
require('../SmartNotification.min.js');

module.exports = {
	init: function () {
		if (window.jQuery('#personal-profile').length > 0) {
			window.jQuery('#personal-profile').on('click', '.confirm', function (e) {
				var $this = window.jQuery(this);
				var msg = $this.data('confirm');
				var deleteurl = $this.data('deleteurl');

				window.jQuery.SmartMessageBox(
					{
						title: 'Confirm Delete',
						content: msg,
						buttons: '[Cancel][DELETE]'
					},
					function (btn) {
						if (btn === 'DELETE') {
							document.location.href = deleteurl;
						}
					}
				);
			});
		}
	}
};
